import React from "react";
import ReactDOM from "react-dom";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import App from "./App";
import outputPdf from "./components/outputPDF"
import $ from "jquery";

const rootElement = document.getElementById("root");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  rootElement
);

const exportButton = document.getElementById("exportButton");
exportButton.onclick = printDocument;

// function printDocument() {
//   html2canvas(resultDiv, {scrollY: -window.scrollY})
//     .then((canvas) => {
//       console.log("satrt to save png");
//       const imgData = canvas.toDataURL('image/jpeg', 1.0);
//       const pdf = new jsPDF();
//       pdf.addImage(imgData, 'JPEG', 10, 10);
//       // pdf.output('dataurlnewwindow');
//       pdf.save("download.pdf");
//     })
//   ;
// }

function printDocument() {
  const resultDiv = document.getElementById("markdown-body");
  console.log( exportButton );
  console.log( resultDiv );
  console.log( resultDiv.offsetHeight );

  outputPdf({
    element: resultDiv,
    contentWidth: 500, // 0-592.28
    contentHeight: 800, // 0-841.89
    mode: 'fixed'
  });
}